module.exports = __webpack_public_path__ + "img/ic-cod.6c3ba4f4.svg";